import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

/**
 * Groups Batch B — safe client configuration (rollout flag, limits, enums).
 * Rollout gate only: when `visible` is false the navigation and routes are hidden AND
 * every /api/groups route answers 404, so hiding UI is UX, never the authorization.
 */
export default function useGroupsConfig() {
  const { data, isLoading } = useQuery({
    queryKey: ["groups-config"],
    queryFn: async () => (await api.get("/groups/config")).data,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return {
    loading: isLoading,
    visible: Boolean(data?.visible),
    limits: data?.limits || {},
    enums: data?.enums || {},
  };
}
